import { z } from 'zod';

/**
 * Validaciones cliente del formulario de categoría de control (ADR-032b),
 * espejo del `CreateCategoriaControlDto`:
 *
 *  - `tipo`: `Operacion` | `Mantenimiento`, requerido.
 *  - `codigo`: ≤ 50, opcional.
 *  - `nombre`: 1..200, requerido.
 *  - `descripcion`: ≤ 1000, opcional.
 *
 * `tipoControl` y `orden` no se editan en el formulario: el primero viene del
 * contexto (sección condición/indicador) y el segundo se autoasigna (máx + 1).
 */
export const categoriaControlFormSchema = z.object({
  tipo: z.enum(['Operacion', 'Mantenimiento']),
  codigo: z.string().trim().max(50, 'Máximo 50 caracteres.').optional().or(z.literal('')),
  nombre: z.string().trim().min(1, 'El nombre es obligatorio.').max(200, 'Máximo 200 caracteres.'),
  descripcion: z.string().trim().max(1000, 'Máximo 1000 caracteres.').optional().or(z.literal('')),
});

export type CategoriaControlFormValues = z.infer<typeof categoriaControlFormSchema>;
